import { render, staticRenderFns } from "./cur_load.vue?vue&type=template&id=4a0d77a8&scoped=true&"
import script from "./cur_load.vue?vue&type=script&lang=js&"
export * from "./cur_load.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0d77a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0d77a8')) {
      api.createRecord('4a0d77a8', component.options)
    } else {
      api.reload('4a0d77a8', component.options)
    }
    module.hot.accept("./cur_load.vue?vue&type=template&id=4a0d77a8&scoped=true&", function () {
      api.rerender('4a0d77a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/dashboard/addon/cur_load.vue"
export default component.exports